import { toast } from "react-toastify"

import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi from "util/api"

import { Paginated, Tag, TagHistoryRow, UserTagRow } from "./type"

class UserTagsService {
  public async getUserTags(userId: string): Promise<UserTagRow[] | void> {
    try {
      const { data } = await useApi.get<IResponse<UserTagRow[]>>(REQ.ADMIN_DASHBOARD.USER_TAGS.LIST.replace(":userId", userId))
      if (data?.success) return data.response
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to get user tags")
    }
  }

  public async getAvailableTags(userId: string): Promise<Tag[] | void> {
    try {
      const { data } = await useApi.get<IResponse<Tag[]>>(REQ.ADMIN_DASHBOARD.USER_TAGS.AVAILABLE.replace(":userId", userId))
      if (data?.success) return data.response
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to get available tags")
    }
  }

  public async assignTag(userId: string, tagId: string): Promise<{ created: boolean } | void> {
    try {
      const url = REQ.ADMIN_DASHBOARD.USER_TAGS.ASSIGN.replace(":userId", userId).replace(":tagId", tagId)
      const { data } = await useApi.post<IResponse<{ created: boolean }>>(url)
      if (data?.success) return data.response
    } catch (err: any) {
      toast.error(err?.data?.message ?? err?.message ?? "Failed to assign tag")
    }
  }

  public async removeTag(userId: string, tagId: string): Promise<{ removed: boolean } | void> {
    try {
      const url = REQ.ADMIN_DASHBOARD.USER_TAGS.REMOVE.replace(":userId", userId).replace(":tagId", tagId)
      const { data } = await useApi.delete<IResponse<{ removed: boolean }>>(url)
      if (data?.success) return data.response
    } catch (err: any) {
      toast.error(err?.data?.message ?? err?.message ?? "Failed to remove tag")
    }
  }

  public async getHistory(userId: string, params?: { page?: number; limit?: number }): Promise<Paginated<TagHistoryRow> | void> {
    try {
      const { data } = await useApi.get<IResponse<Paginated<TagHistoryRow>>>(
        REQ.ADMIN_DASHBOARD.USER_TAGS.HISTORY.replace(":userId", userId),
        { params }
      )
      if (data?.success) return data.response
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to get tag history")
    }
  }
}

export const userTagsService = new UserTagsService()
